// Extract to hook to make it possible to mock in tests
export const useClipboard = () => {
  const copy = async (text: string) => {
    await navigator.clipboard.writeText(text);
  };

  return { copy };
};
